export default "__VITE_ASSET__BADhdyvN__"